import axios from "axios";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();

export async function createQuestion(payload) {
  const token = localStorage.getItem("accessToken");
  try {
    const response = await axios.post("merchant/create-question", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    console.error(error);
    throw new Error("Trivia could not be created");
  }
}

export async function getQuestions() {
  try {
    const response = await api.get("merchant/get-all-questions", null);
    return response;
  } catch (error) {
    console.error(error);
    throw new Error("Questions could not be loaded");
  }
}

export async function getQuestionSets() {
  try {
    const response = await api.get("merchant/get-question-sets", null);
    return response;
  } catch (error) {
    console.error(error);
    throw new Error("Question Sets could not be loaded");
  }
}

export async function getQuestionPerSet(id) {
  try {
    const response = await api.get(`merchant/get-question-set/${id}`, null);
    return response;
  } catch (error) {
    throw new Error("Questions per set could not be loaded");
  }
}

export async function createQuestionSetApi(payload) {
  const token = localStorage.getItem("accessToken");
  try {
    const response = await axios.post("merchant/create-question-set", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    console.error(error);
    throw new Error("Question Set could not be created");
  }
}